module.exports = __webpack_public_path__ + "static/media/smallScernUser.33cdab23.svg";